<template>

  <div class="short-page">
      <panel>
          <p slot="header">
              {{ msg }}
          </p>
          <ui-button color="primary" @click.prevent="goLogin">Zaloguj się</ui-button>
      </panel>
  </div>

</template>

<script>
import Config from './../services/Config'

export default {
  data () {
    return {
      msg: Config.name + '. Witaj, prosimy się zalogować'
    }
  },
  methods: {
    goLogin: function () {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>




// WEBPACK FOOTER //
// Home.vue?43271d6f